<template>
    <div class="table-responsive">
        <table class="table align-items-center table-flush table-hover">
            <thead class="thead-light">
                <tr>
                    <th class="text-left" scope="col">Orden Compra</th>
                    <th class="text-center" scope="col">Rut</th>
                    <th class="text-center" scope="col">Fecha Trans.</th>
                    <th class="text-right" scope="col">Monto</th>
                    <th class="text-left" scope="col">Estado Autofact</th>
                    <th class="text-center" scope="col">Informe PDF</th>
                    <th class="text-left" scope="col">Detalles</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(t, index) in transactions" :key="'t_index'+index">
                    <td class="text-uppercase text-left">
                        <strong>{{ t.oc }}</strong>
                    </td>
                    <td class="text-center">
                        {{ t.rut | formatRut }}
                    </td>
                    <td class="text-center">{{ t.start_date | formatDateTime }}</td>
                    <td class="text-right">{{ t.amount != null ? t.amount : '--' | currency }}</td>
                    <td class="text-left">
                        <span class="badge badge-dot mr-4">
                            <i :class="checkAutofactStatus(t.status_autofact, t.error_autofact, t.pdf_autofact).class"></i>
                            <span>{{checkAutofactStatus(t.status_autofact, t.error_autofact, t.pdf_autofact).text}}</span>
                        </span>
                        <span v-if="t.status_autofact === ERROR" class="small text-danger d-block">Contacte a sistemas</span>
                    </td>
                    <td class="text-center">
                        <a v-if="t.pdf_autofact" :href="t.pdf_autofact" target="_blank" download class="btn btn-link btn-info btn-sm"><i class="fas fa-download mr-1"></i> Descargar</a>
                        <span v-else-if="t.status_autofact === CREATING" class="fas fa-clock-o text-info "></span>
                        <span v-else class="text-muted small d-block">--</span>
                    </td>
                    <td class="text-left">
                        <span class="text-muted">{{ checkAutofactStatus(t.status_autofact, t.error_autofact, t.pdf_autofact).info }}</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
import moment from 'moment'
import formatCurrency from '@/helpers/utils'
import { format as FormatRut } from 'rut.js'
import { ERROR, CREATING, DELIVERED, WITHOUT_INFORMATION } from './constants'

export default {
    name:"AutofactPaymentsTable",
    props: ['transactions'],
    data() {
        return {
            ERROR,
            CREATING
        }
    },
    filters: {
        currency(val) {
            return formatCurrency.currency(val)
        },
        formatDateTime(val) {
            return moment(val).format('DD-MM-YYYY, h:mm:ss a')
        },
        formatRut(val) {
            return val ? FormatRut(val) : "--";
        }
    },
    methods: {
        checkAutofactStatus(status, errorAutofact, urlPDF) {
            status = status ? status.toString().trim().toUpperCase() : null;
            switch (status) {
                case DELIVERED:
                    if(!urlPDF && !errorAutofact) {
                        return { class: 'bg-info', text: 'Desconcido', info: "La solicitud aún no se valida con Autofact." }
                    }
                    return errorAutofact === WITHOUT_INFORMATION ? { class: 'bg-danger', text: 'Información Incompleta', info: "Solicitud con Patente incorrecta" } : { class: 'bg-success', text: 'Finalizado', info: "PDF Generado" }
                case CREATING:
                    return { class: 'bg-info', text: 'Desconcido', info: "La solicitud aún no se valida con Autofact"}
                case ERROR:
                    return { class: 'bg-danger', text: 'Incompleto', info: "Ocurrió un error con la solicitud"}
                default:
                    return { class: 'bg-default', text: 'Otro', info: "Estatus no se conoce"}
            }
        }
    }
}

</script>